/**
 * Dialects Enum
 * Extracted to separate file to avoid circular dependencies
 * between constants.ts and dialects.config.ts
 */

export enum DialectsEnum {
  HARYANVI = "haryanvi",
  RAJASTHANI = "rajasthani",
  BHOJPURI = "bhojpuri",
  GUJARATI = "gujarati",
}
